module.exports = __webpack_public_path__ + "static/media/logo-1.f17de55d.png";